export default __webpack_public_path__ + "static/media/badsound.bbf3c054.mp3";